import templateOnly from '@ember/component/template-only';

export default templateOnly<{
  Blocks: {
    topBar?: [];
    content: [];
    footer?: [];
  };
}>();
